var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-end",style:({ height: (_vm.maxHeight + "px") })},_vm._l((_vm.bins),function(bin,i){return _c('div',{key:bin.x0,staticClass:"flex-grow",style:({
      height: ((bin.length * _vm.binHeightScale) + "px"),
      background: _vm.colorScale ? _vm.colorScale(_vm.binValues[i]) : _vm.color,
    })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }